import React, { useEffect } from 'react'
import LoginPage from '../../../templates/Auth'
import PageLoading from '../PageLoading'
import { routes } from 'core/const/routes'
import { useRouter } from 'next/router'
import useAuth from '../../../hooks/useAuth'

export const withAuth = <T extends object>(C: React.FC<T>) => {
  return class AuthComponent extends React.Component<T> {
    render() {
      return (
        <WithAuthProviderMemo>
          <C {...this.props} />
        </WithAuthProviderMemo>
      )
    }
  }
}

export default withAuth

interface IProps {
  children: React.ReactNode
}
const WithAuthProvider = ({ children }: IProps) => {
  const { logado, loading, usuario } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (!logado && !loading) {
      router.replace(routes.login)
    }
  }, [logado, usuario, loading])

  const SwitchCase = ({ children, router }: any) => {
    if (loading) {
      return <PageLoading />
    }

    if (!logado) {
      return <LoginPage />
    }

    return <div>{children}</div>
  }

  return (
    <>
      <SwitchCase router={router}>{children}</SwitchCase>
    </>
  )
}

const WithAuthProviderMemo = React.memo(WithAuthProvider)
